import classes from "./PieChartCardReport.module.css";
import { Chart } from "chart.js";
import { pieChartPercentageCalculator } from "../../util/genPieChartData";
import Donut from "./Donut";
export default function PieCharCardReport({ children, data, bName }) {
  // console.log("fffffffffffffffffffff Chart Card");
  // console.log(data);

  let percentageData = pieChartPercentageCalculator(data);
  // console.log(percentageData);

  const backgroundColor = [
    "rgba(79, 60, 220, 1)",
    "rgba(71, 208, 119 )",
    "rgba(255, 206, 86 )",
    "rgba(255, 0, 55, 1)",

    "rgba(255, 159, 64 )",
    "rgba(75, 192, 192, 0.8)",
    "rgba(135, 29, 122, 1)",
  ];

  // const pie = new Chart(document.getElementById("testPie"), {
  //   type: "pie",
  //   data: {
  //     labels: [4, 3, 5],
  //     datasets: [{ lable: "hello brother", data: [2, 5, 6] }],
  //   },
  // });

  let branches = JSON.parse(localStorage.getItem("branches"));
  return (
    <div className={classes.container}>
      {branches.length > 1 && <p>{bName}</p>}
      <div className={classes.percentageContainer}>
        <div>
          {percentageData.map((pdata, index) => {
            return (
              <div key={`fds${index}`}>
                <div
                  style={{
                    backgroundColor: `${backgroundColor[index]}`,
                    color: `${backgroundColor[index]}`,
                  }}
                  className={classes.colorBox}
                >
                  hello199
                </div>
                <span>
                  {`${percentageData[index].optionTitle} : ${percentageData[index].percentage}%`}
                </span>
              </div>
            );
          })}
        </div>

        {/* loop ends here */}
      </div>

      {children}
    </div>
  );
}
